<template>
  <div class="nav">
    <ul class="menu">
      <li
        v-for="item in navList"
        :key="item.icon"
        :class="{
          active: currentPage == item.pathName
        }"
        @click="linkTo(item.path)"
      >
        <i :class="item.icon"></i>
        <span>{{ item.title }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navList: [
        {
          icon: 'icon-home',
          title: '首页',
          pathName: 'agent',
          path: '/agent'
        },
        {
          icon: 'icon-agent',
          title: '代理商',
          pathName: 'promoters',
          path: '/promoters'
        }
      ]
    }
  },
  computed: {
    currentPage() {
      return this.$route.name
    }
  },
  methods: {
    linkTo(path) {
      this.$router.push(path)
    }
  }
}
</script>
